import styled from 'styled-components';
import { Button } from '../Shared/FormStyles';

export const ActionsContainer = styled.div`
	display: flex;
	gap: 1rem;
	margin-bottom: 1rem;
`;

export const StatsButton = styled(Button)`
	background-color: #28a745;
`;

// ── Tabs (users / game stickers) ──
export const TabBar = styled.div`
	display: flex;
	gap: 0.25rem;
	margin-bottom: 0;
	border-bottom: 1px solid #dde3e8;
`;

export const Tab = styled.button<{ $active: boolean }>`
	appearance: none;
	border: 1px solid transparent;
	border-bottom: none;
	background: transparent;
	padding: 0.55rem 1.1rem;
	font-size: 0.95em;
	color: ${({ $active }) => ($active ? '#2c3e50' : '#7a8a99')};
	font-weight: ${({ $active }) => ($active ? 600 : 400)};
	cursor: pointer;
	border-radius: 8px 8px 0 0;
	margin-bottom: -1px;

	${({ $active }) =>
		$active
			? `
				background: #fff;
				border-color: #dde3e8;
				`
			: ''}

	&:hover {
		color: #2c3e50;
	}
`;

export const TabContent = styled.div`
	padding-top: 1.25rem;
	background: #fff;
	border: 1px solid #dde3e8;
	border-top: none;
	border-radius: 0 0 10px 10px;
	padding: 1.25rem 1.25rem 0.5rem;
`;
